<template>
    <div>
        Service Unavilable
    </div>
</template>

<script>
import Staff from '@/model/instance/Staff'

export default {
    mounted : function () {
        this.$store.commit('clearLoading')
        Staff.setToken(null)
        if(this.$route.params.response == undefined){
            console.log(this.$route.params)
        }else if(this.$route.params.response.data.error_code==1){
            this.$router.replace({name:'Login'}) 
        }
    },
}
</script>

